"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _IfAnonymousUser = require("./IfAnonymousUser");
Object.keys(_IfAnonymousUser).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _IfAnonymousUser[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _IfAnonymousUser[key];
        }
    });
});
var _IfLoggedInUser = require("./IfLoggedInUser");
Object.keys(_IfLoggedInUser).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _IfLoggedInUser[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _IfLoggedInUser[key];
        }
    });
});
var _LegacyTokenService = require("./LegacyTokenService");
Object.keys(_LegacyTokenService).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _LegacyTokenService[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _LegacyTokenService[key];
        }
    });
});
var _MockedTokenProvider = require("./MockedTokenProvider");
Object.keys(_MockedTokenProvider).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _MockedTokenProvider[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _MockedTokenProvider[key];
        }
    });
});
var _PrefetchedTokenProvider = require("./PrefetchedTokenProvider");
Object.keys(_PrefetchedTokenProvider).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _PrefetchedTokenProvider[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _PrefetchedTokenProvider[key];
        }
    });
});
var _StandaloneTokenProvider = require("./StandaloneTokenProvider");
Object.keys(_StandaloneTokenProvider).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _StandaloneTokenProvider[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _StandaloneTokenProvider[key];
        }
    });
});
var _tokenContext = require("./tokenContext");
Object.keys(_tokenContext).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _tokenContext[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _tokenContext[key];
        }
    });
});
var _UniversalTokenProvider = require("./UniversalTokenProvider");
Object.keys(_UniversalTokenProvider).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _UniversalTokenProvider[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _UniversalTokenProvider[key];
        }
    });
});
var _useToken = require("./useToken");
Object.keys(_useToken).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _useToken[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _useToken[key];
        }
    });
});
var _useUniversalToken = require("./useUniversalToken");
Object.keys(_useUniversalToken).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _useUniversalToken[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _useUniversalToken[key];
        }
    });
}); //# sourceMappingURL=index.js.map
